/* eslint-disable react/no-array-index-key */
/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { FC, ReactElement, useEffect, useRef, useState } from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import * as yup from 'yup'
import { Formik, FieldArray } from 'formik'
import { Form, Alert } from 'react-bootstrap'
import _ from 'lodash'
import API from '@aws-amplify/api'
import { ListItem, ListItemText, Divider, Button as MaterialButton } from '@material-ui/core'
import { observer, inject } from 'mobx-react'
import { Editor } from '@tinymce/tinymce-react'
import { FcSettings } from 'react-icons/fc'
import useWindowSize from '../../../utils/windowSize'
import {
  Template,
  Prospects as ProspectsStore,
  MasterTemplatesObject,
} from '../../../stores/prospects'
import { Settings as SettingsStore } from '../../../stores/settings'
import LoadingButton from '../../../components/LoadingButton'
import { ToastTypeEnum } from '../../../components/Dashboard/Toasts'
import DaysPopper from '../../../components/Dashboard/Prospects/UserInfo/Templates/DaysPopper'

interface Props extends RouteComponentProps {
  prospects?: ProspectsStore
  settings?: SettingsStore
  maneuverType: 'first touch' | 'follow up' | 'nurture'
  currentCampaign: string
  templates?: Template[]
  daysBetween?: string[]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  innerRef: any
}

const schema = yup.object({
  touches: yup.array().of(
    yup.object({
      daysBetween: yup.number().required('Days between change is required'),
      subject: yup.string().required('Email subject is required'),
      body: yup.string().required('Email body is required'),
    }),
  ),
})

const TouchesForm: FC<Props> = ({
  prospects,
  settings,
  maneuverType,
  currentCampaign,
  templates,
  daysBetween: days,
  innerRef,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [openDaysPopper, setOpenDaysPopper] = useState(false)
  const [currentType, setCurrentType] = useState(0)
  const height = useWindowSize()
  const anchorRef = useRef<HTMLButtonElement>(null)
  const prevOpen = React.useRef(openDaysPopper)
  let emailBodyHeight = 150
  if (height > 825) {
    emailBodyHeight = 150 + height - 825
  }
  useEffect(() => {
    if (prevOpen.current === true && openDaysPopper === false) {
      anchorRef?.current?.focus()
    }

    prevOpen.current = openDaysPopper
  }, [openDaysPopper])
  const handleTypeChange = (newValue: number): void => {
    setCurrentType(newValue)
  }

  const touches = templates?.map((template, i) => ({
    ...template,
    daysBetween: _.get(days, i),
    sendOnReply: template.sendOnReply || false,
    thread: template.thread || false,
    disabled: template.disabled || false,
  }))

  const handleToggleDaysPopper = (): void => {
    setOpenDaysPopper(prev => !prev)
  }
  const handleTextChange = (
    event: {
      target: {
        getContent: () => string
      }
    },
    setFieldValue: (field: string, value: string) => void,
    field: string,
  ): void => {
    let str = event.target.getContent()
    str = str.replaceAll('<p class="p2">&nbsp;</p>\n', '')
    str = str.replaceAll('<p class="p1"><br /></p>\n', '')
    str = str.replaceAll('&nbsp;&nbsp;', '')
    str = str.replaceAll('<p class="p1"><br />&nbsp;&nbsp;</p>\n', '')
    str = str.replaceAll(
      '<p class="p2">&nbsp;</p>\n<p class="p2">&nbsp;</p>',
      '<p class="p2">&nbsp;</p>',
    )
    setFieldValue(field, str)
  }

  const handlePriceDemo = (): void => {
    window.open('https://form.typeform.com/to/C871Jx6g', '_blank')
  }

  const updateTemplate = async (values: {
    touches?: {
      daysBetween?: string
      subject: string
      body: string
      sendOnReply: boolean
      thread: boolean
      disabled: boolean
    }[]
  }): Promise<void> => {
    setIsLoading(true)

    let templateType = ''
    switch (maneuverType) {
      case 'first touch':
        templateType = 'firstTouch'
        break
      case 'follow up':
        templateType = 'followUp'
        break
      case 'nurture':
      default:
        templateType = 'nurture'
    }

    let myInit = {}

    if (prospects?.masters && values.touches) {
      const combinedMasters = {
        ...prospects?.masters,
        daysBetween: {
          ...prospects.masters.daysBetween,
          [templateType]: {
            ...prospects.masters.daysBetween[templateType],
            [currentCampaign]: values.touches.map(t => `${t.daysBetween}`),
          },
        },
        [templateType]: {
          ...prospects.masters[templateType],
          [currentCampaign]: values.touches?.map(t => ({
            body: t.body,
            subject: t.subject,
            sendOnReply: t.sendOnReply,
            thread: t.thread,
            disabled: t.disabled,
          })),
        },
      }

      const payload = combinedMasters

      myInit = {
        body: payload,
      }
    } else {
      setIsLoading(false)

      return
    }

    try {
      const response: { templates: MasterTemplatesObject } = await API.put(
        'mav-outlook-api',
        '/users/masterTemplates',
        myInit,
      )

      prospects.setMasters(response.templates)

      settings?.pushToToasts({
        type: ToastTypeEnum.INFO,
        message:
          "Your changes are being processed. It will take some time before they're available on this page.",
      })

      setIsLoading(false)
    } catch (e) {
      console.error(e)

      setIsLoading(false)
    }
  }

  return (
    <Formik
      validationSchema={schema}
      onSubmit={updateTemplate}
      innerRef={innerRef}
      initialValues={{
        touches,
      }}
      enableReinitialize
    >
      {({
        handleSubmit,
        values,
        handleChange,
        touched,
        errors,
        submitCount,
        setFieldValue,
      }): ReactElement => {
        return (
          <Form noValidate onSubmit={handleSubmit}>
            <FieldArray name="touches">
              {(): ReactElement => {
                return (
                  <>
                    <div className="modal_section">
                      {templates?.map((template, i) => (
                        <ListItem
                          button
                          className={`mav-modal-title ${currentType === i ? 'active' : ''}`}
                          key={`${i} + 1`}
                          onClick={() => handleTypeChange(i)}
                        >
                          <ListItemText primary={`EMAIL #${i + 1}`} />
                        </ListItem>
                      ))}
                    </div>
                    <Divider />
                    {templates?.map((template, i) => {
                      const daysBetween = {
                        value: _.get(values, `touches.${i}.daysBetween`),
                        touched: _.get(touched, `touches.${i}.daysBetween`),
                        errors: _.get(errors, `touches.${i}.daysBetween`),
                      }
                      const sendOnReply = {
                        value: _.get(values, `touches.${i}.sendOnReply`),
                        touched: _.get(touched, `touches.${i}.sendOnReply`),
                        errors: _.get(errors, `touches.${i}.sendOnReply`),
                      }
                      const thread = {
                        value: _.get(values, `touches.${i}.thread`),
                        touched: _.get(touched, `touches.${i}.thread`),
                        errors: _.get(errors, `touches.${i}.thread`),
                      }
                      const disabled = {
                        value: _.get(values, `touches.${i}.disabled`),
                        touched: _.get(values, `touches.${i}.disabled`),
                        errors: _.get(errors, `touches.${i}.disabled`),
                      }

                      const subject = {
                        value: _.get(values, `touches.${i}.subject`),
                        touched: _.get(touched, `touches.${i}.subject`),
                        errors: _.get(errors, `touches.${i}.subject`),
                      }

                      const body = {
                        value: _.get(values, `touches.${i}.body`),
                        touched: _.get(touched, `touches.${i}.body`),
                        errors: _.get(errors, `touches.${i}.body`),
                      }
                      if (currentType === i) {
                        return (
                          <div className="email_section">
                            <div style={{ flex: 3 }}>
                              <div className="email-first-line p-2">
                                {i !== 0 && (
                                  <MaterialButton
                                    ref={anchorRef}
                                    aria-controls={openDaysPopper ? 'days-popper' : undefined}
                                    aria-haspopup="true"
                                    className="trash"
                                    onClick={handleToggleDaysPopper}
                                  >
                                    <FcSettings
                                      className={`${openDaysPopper ? 'active-delete' : ''}`}
                                    />
                                  </MaterialButton>
                                )}
                                {i !== 0 && (
                                  <DaysPopper
                                    openDaysPopper={openDaysPopper}
                                    anchorRef={anchorRef}
                                    setOpenDaysPopper={setOpenDaysPopper}
                                  >
                                    <Form.Group
                                      controlId={`days-after-touch-${i}`}
                                      className="days-after"
                                    >
                                      <Form.Label>{`Days after touch ${i}?`}</Form.Label>
                                      <Form.Control
                                        type="number"
                                        min={1}
                                        name={`touches.${i}.daysBetween`}
                                        required
                                        value={daysBetween.value}
                                        onChange={handleChange}
                                        isInvalid={submitCount > 0 && !!daysBetween.errors}
                                      />
                                      <Form.Control.Feedback type="invalid">
                                        <Alert variant="danger">{daysBetween.errors}</Alert>
                                      </Form.Control.Feedback>
                                    </Form.Group>
                                    <div className="checkboxs">
                                      <Form.Group controlId={`touches.${i}.disabled`}>
                                        <Form.Check
                                          type="checkbox"
                                          id="disabled-checkbox"
                                          className="email-meta-checkbox"
                                          name={`touches.${i}.disabled`}
                                          label="Disable this touch. Disabling one touch will disable all touches after it."
                                          checked={disabled.value}
                                          onChange={(e): void => {
                                            const touchesLength = touches?.length || 0
                                            if (e?.target?.checked) {
                                              let touchIndex = 0
                                              while (touchIndex < touchesLength) {
                                                if (i <= touchIndex) {
                                                  setFieldValue(
                                                    `touches.${touchIndex}.disabled`,
                                                    true,
                                                  )
                                                }
                                                touchIndex += 1
                                              }
                                            } else if (_.get(values, `touches.${i - 1}.disabled`)) {
                                              prospects?.pushToToasts({
                                                type: ToastTypeEnum.ERROR,
                                                message:
                                                  'You cannot enable this touch without enabling all prior touches',
                                              })
                                            } else {
                                              handleChange(e)
                                            }
                                          }}
                                        />
                                      </Form.Group>
                                      <Form.Group controlId={`touches.${i}.sendOnReply`}>
                                        <Form.Check
                                          type="checkbox"
                                          id="send-on-reply-checkbox"
                                          className="email-meta-checkbox"
                                          name={`touches.${i}.sendOnReply`}
                                          label="Send on Reply"
                                          checked={sendOnReply.value}
                                          onChange={handleChange}
                                        />
                                      </Form.Group>
                                      <Form.Group controlId={`touches.${i}.thread`}>
                                        <Form.Check
                                          type="checkbox"
                                          id="thread-checkbox"
                                          className="email-meta-checkbox"
                                          name={`touches.${i}.thread`}
                                          label="Thread this touch to previous touch"
                                          checked={thread.value}
                                          onChange={handleChange}
                                        />
                                      </Form.Group>
                                    </div>
                                  </DaysPopper>
                                )}
                                <Form.Group
                                  controlId={`email-subject-touch-${i}`}
                                  className="email-subject"
                                >
                                  <Form.Label>Email Subject</Form.Label>
                                  <Form.Control
                                    spellCheck="true"
                                    type="text"
                                    name={`touches.${i}.subject`}
                                    required
                                    value={subject.value}
                                    onChange={handleChange}
                                    isValid={subject.touched && !subject.errors}
                                    isInvalid={submitCount > 0 && !!subject.errors}
                                  />
                                </Form.Group>
                                <Form.Control.Feedback type="invalid">
                                  <Alert variant="danger">{subject.errors}</Alert>
                                </Form.Control.Feedback>
                              </div>
                              <Form.Group
                                controlId={`email-body-touch-${i}`}
                                className="email-body-group px-2"
                              >
                                <Form.Label>Email Body</Form.Label>
                                <Editor
                                  textareaName={`touches.${i}.body`}
                                  // className="email-body-textarea"
                                  apiKey="dc71buijbp92lbdveqijzgigj9gxfosqm6li1pr7o1s20vds"
                                  value={body.value}
                                  id={`${maneuverType}-email-body-touch-${i}`}
                                  init={{
                                    browser_spellcheck: true,
                                    branding: false,
                                    br_in_pre: false,
                                    height: emailBodyHeight,
                                    menu: {
                                      custom: {
                                        title: 'Custom Menu',
                                        items: 'undo redo myCustomMenuItem',
                                      },
                                    },
                                    menubar: false,
                                    contextmenu: false,
                                    plugins: [
                                      'advlist autolink lists link',
                                      'searchreplace visualblocks',
                                      'paste wordcount',
                                    ],
                                    setup: (editor): void => {
                                      editor.ui.registry.addMenuButton('menuDateButton', {
                                        text: 'Variables',
                                        // toolbar_sticky: false,
                                        fetch(callback) {
                                          const itemsArr: {
                                            type: 'togglemenuitem' | undefined
                                            text: string
                                            onAction: () => void
                                          }[] = [
                                            {
                                              type: 'togglemenuitem',
                                              text: 'First Name',
                                              onAction: (): void => {
                                                editor.insertContent('{FirstName}')
                                              },
                                            },
                                            {
                                              type: 'togglemenuitem',
                                              text: 'Last Name',
                                              onAction: (): void => {
                                                editor.insertContent('{LastName}')
                                              },
                                            },
                                            {
                                              type: 'togglemenuitem',
                                              text: 'Company Name',
                                              onAction: (): void => {
                                                editor.insertContent('{CompanyName}')
                                              },
                                            },
                                            {
                                              type: 'togglemenuitem',
                                              text: 'Title',
                                              onAction: (): void => {
                                                editor.insertContent('{Title}')
                                              },
                                            },
                                            {
                                              type: 'togglemenuitem',
                                              text: 'Industry',
                                              onAction: (): void => {
                                                editor.insertContent('{Industry}')
                                              },
                                            },
                                            {
                                              type: 'togglemenuitem',
                                              text: 'Opt Out Message',
                                              onAction: (): void => {
                                                editor.setContent(
                                                  `${editor.getContent()} <p>To stop receiving emails similar to this one, reply "Unsubscribe" </p>`,
                                                  { format: 'html' },
                                                )
                                              },
                                            },
                                          ]
                                          if (
                                            settings?.signatures &&
                                            settings?.signatures[0] &&
                                            settings?.signatures[0].id !== 'null'
                                          ) {
                                            itemsArr.push({
                                              type: 'togglemenuitem',
                                              text: 'Signature',
                                              onAction: (): void => {
                                                editor.insertContent('{Signature}')
                                              },
                                            })
                                          }
                                          callback(itemsArr)
                                        },
                                      })
                                    },
                                    toolbar:
                                      'menuDateButton | fontselect | bold italic bullist numlist outdent indent | link',
                                  }}
                                  onEditorChange={(value): void => {
                                    setFieldValue(`touches.${i}.body`, value)
                                  }}
                                  onChange={(value): void => {
                                    handleTextChange(value, setFieldValue, `touches.${i}.body`)
                                  }}
                                />
                              </Form.Group>
                              <Form.Control.Feedback type="invalid">
                                <Alert variant="danger">{body.errors}</Alert>
                              </Form.Control.Feedback>
                            </div>
                            <div className="btn_section p-2" style={{ flex: 1 }}>
                              <Form.Group
                                controlId="actions-btn"
                                className="save-template-group px-2"
                              >
                                <LoadingButton
                                  variant="primary"
                                  isLoading={isLoading}
                                  type="submit"
                                  block
                                >
                                  Save Template
                                </LoadingButton>
                              </Form.Group>
                              <Form.Group
                                controlId="actions-btn"
                                className="save-template-group px-2"
                              >
                                <LoadingButton
                                  variant="primary"
                                  isLoading={isLoading}
                                  type="button"
                                  onClick={(): void => handlePriceDemo()}
                                  block
                                >
                                  Put my templates on autopilot
                                </LoadingButton>
                              </Form.Group>
                            </div>
                          </div>
                        )
                      }
                      return <></>
                    })}
                  </>
                )
              }}
            </FieldArray>
          </Form>
        )
      }}
    </Formik>
  )
}

export default inject('prospects', 'settings')(withRouter(observer(TouchesForm)))
